<script>
	import { onMount } from 'svelte'
	import { fade,crossfade,scale } from 'svelte/transition'
	import { quintOut } from 'svelte/easing'
	import InfoModal from './InfoModal.svelte'
	import ShareModal from './ShareModal.svelte'
	import ArchiveModalGrid from './ArchiveModalGrid.svelte'
	import HamburgerMenu from './HamburgerMenu.svelte';
	import CoupletCounter from './CoupletCounter.svelte'
	import bcrypt from 'bcryptjs'
	
	const localMode = false
	const djangoEndpoint = 'https://ampersandib.uc.r.appspot.com/ampersandi'
	const netlifyEndpoint = '/api'
	const localEndpoint = 'http://127.0.0.1:8000/ampersandi'
	let cacheableEndpoint = netlifyEndpoint
	let nonCacheableEndpoint = djangoEndpoint
	if(localMode){
		cacheableEndpoint = localEndpoint
		nonCacheableEndpoint = localEndpoint
	}

	let puzzledata
	let nextpuzzledate
	let ampersandimages = [
		"images/ampersand01.png",
		"images/ampersand02.png",
		"images/ampersand03.png",
		"images/ampersand04.png",
		"images/ampersand05.png",
		"images/ampersand06.png",
		"images/ampersand07.png",
		"images/ampersand08.png",
		"images/ampersand09.png",
		"images/ampersand10.png",
		"images/ampersand11.png",
		"images/ampersand12.png",
		"images/ampersand13.png",
		"images/ampersand14.png",
		"images/ampersand15.png",
		"images/ampersand16.png",
		"images/ampersand17.png",
		"images/ampersand18.png",
		"images/ampersand19.png",
		"images/ampersand20.png",
	]
	let earlysubmit = false
	let nohintavailable = false
	let isOpenInfoModal = false
	let isOpenShareModal = false
	let isOpenCalendarModal = false
	let hamburgerOpen = false
	let closeableStack = [];
	let calendarKeys = [];
	let calendar = [];

	const trycal = localStorage.getItem("calendar")
	const trynextdate = localStorage.getItem("nextpuzzledate")
	if(trycal){
		calendar=JSON.parse(trycal)
	}
	if(trynextdate){
		nextpuzzledate = trynextdate
	}

	function checkAndCloseStack(e){
		if(e.keyCode === 27 && closeableStack.length > 0	){
			const theFunc = closeableStack.pop()
			theFunc()
		}
	}

	function openShareModal(){
		isOpenShareModal = true
		closeableStack.push(closeShareModal)
		window.addEventListener('keydown', checkAndCloseStack);
	}
	function closeShareModal(){
		isOpenShareModal = false
		//window.removeEventListener('keydown', checkAndCloseStack);
		if(closeableStack.length < 1){
			//focusFirstAnswer()
		}
	}
	function openCalendarModal(){
		isOpenCalendarModal = true
		closeableStack.push(closeCalendarModal)
		window.addEventListener('keydown', checkAndCloseStack);
	}
	function closeCalendarModal(){
		isOpenCalendarModal = false
		//window.removeEventListener('keydown', checkAndCloseStack);
		if(closeableStack.length < 1){
			//focusFirstAnswer()
		}
	}
	function openHamburger(){
		hamburgerOpen = true;
		closeableStack.push(closeHamburgerMenu)
		window.addEventListener('keydown', checkAndCloseStack)
	}
	function closeHamburgerMenu(){
		hamburgerOpen = false;
		//window.removeEventListener('keydown', checkAndCloseStack)
		document.getElementById('hamburgerhelper').focus()
	}
	function openModal(){
		isOpenInfoModal = true
		closeableStack.push(closeModal)
		window.addEventListener('keydown', checkAndCloseStack);
	}
	function closeModal(){
		isOpenInfoModal = false
		//window.removeEventListener('keydown',checkAndCloseStack)
		//focusFirstAnswer()
	}
	function focusFirstAnswer(){
		let curAns = document.getElementById('Answer0')
		if(curAns){
			curAns.focus()
			return true
		}
		curAns = document.getElementById('Answer1')
		if(curAns){
			curAns.focus()
			return true
		}
		curAns = document.getElementById('Answer2')
		if(curAns){
			curAns.focus()
			return true
		}
		return false
	}
	function calcHintsAvailable(){
		if(puzzledata && puzzledata.hints && Object.keys(puzzledata.hints).length>0 && !solved){
			//select a word to clue
			let clueable = []
			//first, clue any empty slots
			for(let i=0;i<puzzState.guesses.length;i++){
				let hint = puzzledata.hints['hint'+(i+1)]
				if(!puzzState.couplets[Math.floor(i/2)].locked 
					&& (
						puzzState.guesses[i]=="" 
					)
				){
					clueable.push(i)
				}
			}

			if(clueable.length < 1){
				//if no empty slots, clue an incorrect word
				for(let i=0;i<puzzState.guesses.length;i++){
					let hint = puzzledata.hints['hint'+(i+1)]
					if(!puzzState.couplets[Math.floor(i/2)].locked 
						&& puzzState.guesses[i] != hint
						&& (
							!bcrypt.compareSync(puzzState.guesses[i] ? replacePretentiousPunctuation(puzzState.guesses[i].trim().toLowerCase()) : "",puzzledata["answer"+(parseInt(i)+1)])
						)
					){
						clueable.push(i)
					}
				}
			}

			if(clueable.length < 1){
				nohintavailable = true
				setTimeout(()=>{nohintavailable=false},5000)
				return false
			}

			//choose a clue
			let chosenclue = clueable[Math.floor(Math.random() * clueable.length)]

			//reveal the clue
			puzzState.guesses[chosenclue] = puzzledata.hints['hint'+(chosenclue+1)]
			puzzState.hintsUsed++
			return true
		}
	}
	function revealHint(){
		if(puzzledata && puzzledata.hints && Object.keys(puzzledata.hints).length>0 && !solved){
			//select a word to clue
			let clueable = []
			//first, clue any empty slots
			for(let i=0;i<puzzState.guesses.length;i++){
				let hint = puzzledata.hints['hint'+(i+1)]
				if(!puzzState.couplets[Math.floor(i/2)].locked 
					&& (
						puzzState.guesses[i]=="" 
					)
				){
					clueable.push(i)
				}
			}

			/*
			if(clueable.length < 1){
				//if no empty slots, clue an incorrect word
				for(let i=0;i<puzzState.guesses.length;i++){
					let hint = puzzledata.hints['hint'+(i+1)]
					if(!puzzState.couplets[Math.floor(i/2)].locked 
						&& puzzState.guesses[i] != hint
						&& (
							!bcrypt.compareSync(puzzState.guesses[i] ? replacePretentiousPunctuation(puzzState.guesses[i].trim().toLowerCase()) : "",puzzledata["answer"+(parseInt(i)+1)])
						)
					){
						clueable.push(i)
					}
				}
			}
			*/

			if(clueable.length < 1){
				nohintavailable = true
				setTimeout(()=>{nohintavailable=false},5000)
				return false
			}

			//choose a clue
			let chosenclue = clueable[Math.floor(Math.random() * clueable.length)]

			//reveal the clue
			puzzState.guesses[chosenclue] = puzzledata.hints['hint'+(chosenclue+1)]
			puzzState.hintsUsed++
			return true
		}
	}
	function revealPuzzle(){
		fetch(nonCacheableEndpoint + `/reveal/` + seqId,{
				method: 'GET',
				headers: myHeaders,
			})
			.then(r => r.json())
			.then(data => {
				if(data.seqId == seqId){
					let didreveal = false
					for(let i=0;i<3;i++){
						if(!puzzState.couplets[i].locked){
							puzzState.guesses[i*2] = data["answer"+(i*2+1)]
							puzzState.guesses[i*2+1] = data["answer"+(i*2+2)]
							puzzState.couplets[i].revealed = true
							puzzState.couplets[i].locked = true
							didreveal = true
						}
					}
					puzzState.revealed = true
					puzzState.recorded = true
					storePuzzleState()
					processCalendar()
					localStorage.setItem('calendar',JSON.stringify(calendar))
				}
			});		
	}

	let winhistory = initWinHistory()
	let seqId = 0
	let result=["","","","","",""]
	let puzzState = {
		recorded:false,
		revealed:false,
		submissions:0,
		title: "",
		guesses:["","","","","",""],
		hintsUsed:0,
		couplets:[
			{
				counter:1,
				locked:false,
				revealed:false
			},
			{
				counter:1,
				locked:false,
				revealed:false
			},
			{
				counter:1,
				locked:false,
				revealed:false
			},
		]	
	}
	$: solved = puzzState.couplets[0].locked && puzzState.couplets[1].locked && puzzState.couplets[2].locked
	//$: console.log("solved: " + solved)
	$: addResult(puzzState.submissions,solved,puzzState.revealed)

	

	//note persist dark mode: https://dev.to/lenaschnedlitz/create-a-simple-dark-mode-toggle-with-svelte-4b3g
	let currentTheme
	const THEMEKEY = 'theme'
	const DARK_PREFERENCE = '(prefers-color-scheme: dark)'
	const THEMES = {
		DARK: 'darkmode',
		LIGHT: 'lightmode',
	}
	const prefersDarkThemes = () => window.matchMedia(DARK_PREFERENCE).matches
	const toggleTheme = () => {
		const stored = localStorage.getItem(THEMEKEY);

		if (stored) {
			// clear storage
			localStorage.removeItem(THEMEKEY);
		} else {
			// store opposite of preference
			localStorage.setItem(THEMEKEY, prefersDarkThemes() ? THEMES.LIGHT : THEMES.DARK);
		}

		applyTheme()
	};
	const applyTheme = () => {
		const preferredTheme = prefersDarkThemes() ? THEMES.DARK : THEMES.LIGHT;
		currentTheme = localStorage.getItem(THEMEKEY) ?? preferredTheme;

		if (currentTheme === THEMES.DARK) {
			document.body.classList.remove(THEMES.LIGHT);
			document.body.classList.add(THEMES.DARK);
		} else {
			document.body.classList.remove(THEMES.DARK);
			document.body.classList.add(THEMES.LIGHT);
		}
	};
	onMount(() => {
		applyTheme()
		window.matchMedia(DARK_PREFERENCE).addEventListener('change', applyTheme)
	})



	

	const [send, receive] = crossfade({
		duration:1500,
		easing: quintOut
	})


	const myHeaders = new Headers()
	myHeaders.append('Content-Type','application/json');
	//myHeaders.append('Authorization',canonicV2Token)

	const urlParams = new URLSearchParams(window.location.search);
    /* puzzle data in form

	*/
	if(!urlParams.has('p')){
		//no puzzle specified. Fetch latest puzzle
		fetch(cacheableEndpoint + `/puzzle/0`,{
			method: 'GET',
			headers: myHeaders
		})
		.then(r => r.json())
		.then(data => {
			puzzledata = data;
			seqId = data.seqId;
			inflatePuzzleState()
		});
	}else{
		//fetch puzzle based on p param
		fetch(cacheableEndpoint + `/puzzle/`+urlParams.get('p'),{
			method: 'GET',
			headers: myHeaders
		})
		.then(r => r.json())
		.then(data => {
			puzzledata = data;
			seqId = data.seqId;
			inflatePuzzleState()
		});		
	}

	//get ad inflate calendar
	const tryCal = localStorage.getItem("calendarKeys")
	if(tryCal){
		calendarKeys = JSON.parse(tryCal)
	}

	//only refresh the calendar every ??? hours
	const refreshStamp = localStorage.getItem('amp_cal_last_refresh')
	const oneHour = 3600000
	if(refreshStamp == null || tryCal == null || Date.now()-refreshStamp > (oneHour * 12)){
		//cal is stale
		fetch(cacheableEndpoint + `/calendar/`,{
			method: 'GET',
			headers: myHeaders
		})
		.then(r => r.json())
		.then(data => {
			if(data){
				nextpuzzledate = data.nextpuzzle
				calendarKeys = data.calendar
				processCalendar()
				localStorage.setItem('amp_cal_last_refresh',Date.now())
				localStorage.setItem('calendarKeys',JSON.stringify(calendarKeys))
				localStorage.setItem('calendar',JSON.stringify(calendar))
				localStorage.setItem('nextpuzzledate',nextpuzzledate)
			}
		});
	}else{
		processCalendar()
		localStorage.setItem('calendar',JSON.stringify(calendar))
	}

	function processCalendar(){
		let temparchive = []
		//process the calendar
		for(let i=0;i<calendarKeys.length;i++){
			const gld = calendarKeys[i].golivedate
			const readdate = parseInt(gld.slice(5,7)) + "/" + parseInt(gld.slice(8,10)) + "/" + gld.slice(2,4)
			let completed = false;
			let started = false;
			let revealed = false;
			let tries = 0;
			let hints = 0;
			let storedState = localStorage.getItem(calendarKeys[i]._id) 
			if(storedState != null){
				started = true
				const storedPuzz = JSON.parse(storedState)
				if(storedPuzz.recorded){
					completed = true
				}
				if(storedPuzz.revealed){
					revealed = true
				}
				tries = storedPuzz.submissions
				hints = storedPuzz.hintsUsed

			}else if(calendarKeys[i].oldId != ""){
				//check for old ID version and update
				storedState = localStorage.getItem(calendarKeys[i].oldId)
				if(storedState != null){
					//move the puzzle
					localStorage.setItem(calendarKeys[i]._id,storedState)
					//delete the old version
					localStorage.removeItem(calendarKeys[i].oldId)
					started = true
					const storedPuzz = JSON.parse(storedState)
					if(storedPuzz.recorded){
						completed = true
					}
					if(storedPuzz.revealed){
						revealed = true
					}
					tries = storedPuzz.submissions
					hints = storedPuzz.hintsUsed
				}
			}

			temparchive.push({
				seqId:calendarKeys[i].seqId,
				_id:calendarKeys[i]._id,
				started:started,
				completed:completed,
				revealed:revealed,
				difficulty:"4/5",
				golivedate:readdate,
				golivedatestamp:calendarKeys[i].golivedate,
				tries:tries,
				hints:hints
			})
		}
		calendar = temparchive.sort(function(a,b){
							if (b.golivedatestamp < a.golivedatestamp)
							return -1;
						else if (a.golivedatestamp == b.golivedatestamp)
							return 0;
						else
							return 1;
					});
	}
	
	function initWinHistory(){
		const stored = localStorage.getItem("winhistory")
		let history
		if(stored){
			history = JSON.parse(stored)
		}else{
			//since no history, open the info modal
			openModal()
			history = [
				{
					label:"&",
					count:0
				},
				{
					label:"&&",
					count:0
				},
				{
					label:"&&&",
					count:0
				},
				{
					label:"&&&&",
					count:0
				},
				{
					label:"&&&&&",
					count:0
				},
				{
					label:"&&&&&+",
					count:0
				}
			]
		}
		return history
	}
	function addResult(turns,solved,revealed){
		if(typeof solved === 'undefined' || !solved || puzzState.recorded){
			return false
		}	
		
		if(!revealed){
			winhistory[parseInt(turns) < 6 ? parseInt(turns)-1 : 5].count++
			localStorage.setItem('winhistory',JSON.stringify(winhistory))
			puzzState.recorded = true
			storePuzzleState()
			//call solved
			fetch(nonCacheableEndpoint + `/solve/`,{
				method: 'POST',
				headers: myHeaders,
				body: JSON.stringify({
					"seqId": seqId,
					"tries":puzzState.submissions,
					"hints":puzzState.hintsUsed,
					"answer1":puzzState.guesses[0],
					"answer2":puzzState.guesses[1],
					"answer3":puzzState.guesses[2],
					"answer4":puzzState.guesses[3],
					"answer5":puzzState.guesses[4],
					"answer6":puzzState.guesses[5],
				})
			})
			.then(r => r.json())
			.then(data => {
				console.log(data)
			});		
			setTimeout(() => openShareModal(),1500)
			processCalendar()
			localStorage.setItem('calendar',JSON.stringify(calendar))
		}
	}
	function storePuzzleState(){
		localStorage.setItem(puzzledata._id,JSON.stringify(puzzState))
		processCalendar()
	}
	function inflatePuzzleState(){
		let stored = localStorage.getItem(puzzledata._id)
		if(stored){
			puzzState = JSON.parse(stored)
			if(!puzzState.hintsUsed){
				puzzState.hintsUsed = 0
			}
		}else if(puzzledata.oldId != ""){
			stored = localStorage.getItem(puzzledata.oldId)
			if(stored){
				//migrate
				localStorage.setItem(puzzledata._id,puzzState)
				localStorage.removeItem(puzzledata.oldId)
				puzzState = JSON.parse(stored)
				if(!puzzState.hintsUsed){
					puzzState.hintsUsed = 0
				}
			}else{
				puzzState.title = puzzledata.title
			}
		}else{
			puzzState.title = puzzledata.title
		}
	}
	function replacePretentiousPunctuation(str){
		str = str.replace('\u2018','\'')
		str = str.replace('\u2019','\'')
		return str
	}
	function checkAnswers(){
		if(!puzzledata || solved){
			return false;
		}
		if(!puzzState.guesses[0] || !puzzState.guesses[1] 
			|| !puzzState.guesses[2] || !puzzState.guesses[3] 
			|| !puzzState.guesses[4] || !puzzState.guesses[5]){
			earlysubmit = true
			setTimeout(() => {earlysubmit=false},5000)
			return false
		}
		puzzState.submissions++

		for(const k in puzzState.guesses){
			result[k] = bcrypt.compareSync(puzzState.guesses[k] ? replacePretentiousPunctuation(puzzState.guesses[k].trim().toLowerCase()) : "",puzzledata["answer"+(parseInt(k)+1)]) ? "correct":"incorrect"
		}
		
		if(result[0] == "incorrect" || result[1] == "incorrect"){
			puzzState.couplets[0].counter++
		}else{
			puzzState.couplets[0].locked = true
		}
		if(result[2] == "incorrect" || result[3] == "incorrect"){
			puzzState.couplets[1].counter++
		}else{
			puzzState.couplets[1].locked = true
		}
		if(result[4] == "incorrect" || result[5] == "incorrect"){
			puzzState.couplets[2].counter++
		}else{
			puzzState.couplets[2].locked = true
		}

		storePuzzleState()

		//alert(resultstr)
	}


	function ordinal(n) {
		var s = ["th", "st", "nd", "rd"];
		var v = n%100;
		return n + (s[(v-20)%10] || s[v] || s[0]);
	}

</script>

<svelte:head>
	{#if urlParams.has('p') && puzzledata}
		<title>{puzzledata.title} | The Ampersandi</title>
	{/if}
</svelte:head>
<div id="outermost" class:darkmode='{currentTheme === THEMES.DARK}'>
<InfoModal isOpenModal={isOpenInfoModal} on:closeModal={closeModal} darkmode={currentTheme === THEMES.DARK}/>
<ShareModal isOpenModal={isOpenShareModal} on:closeModal={closeShareModal} winhistory={winhistory} puzzState={puzzState} releasedate={puzzledata ? puzzledata.golivedate : ""} nextpuzzledate={nextpuzzledate} solved={solved} seqId={seqId}/>
<ArchiveModalGrid isOpenModal={isOpenCalendarModal} on:closeModal={closeCalendarModal} darkmode={currentTheme === THEMES.DARK} calendar={calendar} seqId={seqId}/>
<HamburgerMenu isOpen={hamburgerOpen} on:closeHamburger={closeHamburgerMenu} openShareModal={openShareModal} openCalendarModal={openCalendarModal} switchValue={currentTheme === THEMES.DARK} toggleTheme={toggleTheme}/>

<div id="toprow" role="banner">
	<button id="hamburgerhelper" type="button" aria-label="Open hamburger menu"
		on:click={() => {if(hamburgerOpen){closeHamburgerMenu()}else{openHamburger()}}}
		aria-expanded={hamburgerOpen}
		aria-controls="hamburgermenu"
		>
        <svg viewBox="0 0 80 70" aria-hidden="true">
            <rect width="80" height="10"></rect>
            <rect y="30" width="80" height="10"></rect>
            <rect y="60" width="80" height="10"></rect>
        </svg>
    </button>
	<div class="logo"><a href="/"><img src="images/ampersandi_logo_black_hi.png" alt="Ampersandi logo" /></a></div>
	<div id="infolinkcontainer" class="infolinkcontainer" ><button type="button" id="infolink" class="infolink" href="#" on:click={openModal} aria-label="Open help screen"></button></div>
</div>


{#if puzzledata}
	<div in:fade class="puzzlecontents" role="main">
		<h1 class="sr-only">title of current ampersandi</h1>
		<h3>{puzzledata.title}
			{#if puzzledata.author != ""}
				 by&nbsp;
				 <span class="author">{puzzledata.author}</span>
			{/if}
		</h3>
		<h1 class="sr-only">Ampersandi clues</h1>
		<p class="cluetext" aria-label="ampersandi clues">{@html puzzledata.puzzletext}</p>
		
		<h1 class="sr-only">Ampersandi submission. All 6 inputs must be filled before submitting.</h1>
		<div class="answergrid">

			{#each puzzState.couplets as { counter, locked, revealed }, i}
				{#if locked}
				<h2 class="sr-only">Couplet {i+1} {revealed ? "correct and locked." : "revealed"}</h2>
				{/if}
				<div class="answergriditem leftcol">
					{#if locked}
						{#if revealed}
						<div class="finishedanswer revealedanswer" in:send={{key:i*2}} out:receive={{key:i*2}}>{puzzState.guesses[i*2]}</div>
						{:else}	
						<div class="finishedanswer" in:send={{key:i*2}} out:receive={{key:i*2}}>{puzzState.guesses[i*2]}</div>
						{/if}
					{:else}
					<input 
						type="text" 
						in:send={{key:i*2}} out:receive={{key:i*2}} 
						bind:value={puzzState.guesses[i*2]}
						on:focus={e => {e.target.select()}}
						on:keydown={e => {e.key === 'Enter' && checkAnswers()}}
						id={"Answer"+i}
						aria-label={"Answer for " + ordinal(i + 1) + " couplet left side"}
					>
					{/if}
				</div>
				<div class="answergriditem">
					<span id={"ampersand"+i} class="ampersand">
						{#each ampersandimages as url, j}
							{#if counter == j+1}
							<img 
								src={url} 
								alt={(locked ? revealed ? "red" : "gold" : "black") + " ampersand"}
								class:solved="{locked && !revealed}"
								class:revealed="{revealed}"	
								transition:scale
								aria-label={"Ampersand connecting " + ordinal(i+1) +" couplet"}
							/>
							{/if}
						{/each}
						
					</span>
				</div>
				<div class="answergriditem">
					{#if locked}
						{#if revealed}
						<div class="finishedanswer revealedanswer" in:send={{key:i*2+1}} out:receive={{key:i*2+1}}>{puzzState.guesses[i*2+1]}</div>
						{:else}	
						<div class="finishedanswer" in:send={{key:i*2+1}} out:receive={{key:i*2+1}}>{puzzState.guesses[i*2+1]}</div>
						{/if}
					{:else}
					<input 
						type="text" 
						in:send={{key:i*2+1}} out:receive={{key:i*2+1}} 
						bind:value={puzzState.guesses[i*2+1]}
						on:focus={e => {e.target.select()}}
						on:keydown={e => {e.key === 'Enter' && checkAnswers()}}
						aria-label={"Answer for " + ordinal(i + 1) + " couplet right side"}
					>
					{/if}
				</div>
			{/each}
		</div>
	</div>
	{:else}
	<div class="loading">loading...</div>
	{/if}
	<div class="bottomrow">
		<!--<div id="coupletcounters">
			{#each puzzState.couplets as { counter, locked }, i}
				<CoupletCounter 
					counter={counter}
					locked={locked}
					ampersandimages={ampersandimages}
					i={i} 
				/>
			{/each}
		</div>-->
		<h1 class="sr-only">Message</h1>
		{#if earlysubmit}
			<p class="statusnote" class:horizontalshake="{earlysubmit}" aria-live="polite">
			Nope! Fill out the whole ampersandi first
			</p>
		{:else if nohintavailable}
			<p class="statusnote" class:horizontalshake="{nohintavailable}" aria-live="polite">
			Clear an answer for more hints!
			</p>
		{:else if solved && puzzState.revealed}
		<p class="statusnote" class:horizontalshake="{earlysubmit}" aria-live="assertive">
			{"Womp womp. Revealed after " + puzzState.submissions + " tr" + (puzzState.submissions == 1 ? "y" : "ies") 
				+ (puzzState.hintsUsed > 0 ? " and " + puzzState.hintsUsed + " hint" : "") 
				+ (puzzState.hintsUsed > 1 ? "s":"") + "."}
			</p>
		{:else if solved}
			<p class="statusnote" class:horizontalshake="{earlysubmit}" aria-live="assertive">
				{"Congratulations! You solved it in " + puzzState.submissions + " tr" + (puzzState.submissions == 1 ? "y" : "ies") 
					+ (puzzState.hintsUsed > 0 ? " and " + puzzState.hintsUsed + " hint" : "") 
					+ (puzzState.hintsUsed > 1 ? "s":"") + "."}
				</p>
		{:else}
			<p class="statusnote" class:horizontalshake="{earlysubmit}">
				You've submitted {puzzState.submissions} guess{puzzState.submissions != 1 ? "es":""}{
					(puzzState.hintsUsed > 0 ? " and used " + puzzState.hintsUsed + " hint" : "") 
					+ (puzzState.hintsUsed > 1 ? "s":"")
				}.
			</p>
			{/if}
			
		{#if !solved}
		<button 
			type="button" class="submitbtn" disabled={earlysubmit} 
			on:click={checkAnswers} 
			on:touchend={e => {e.preventDefault(); checkAnswers()}}
		>Submit</button><br>
			<!-- show hint button if there are unused hints available and user has made at least one submission -->
			<div class="hintrowbtn"><a href="#" class="hint" on:click={revealHint}>Hint</a></div>| 
			<div class="hintrowbtn"><a href="#" class="hint" on:click={revealPuzzle}>Reveal</a></div>
		{:else}
		<button type="button" class="submitbtn" on:click={openShareModal}>Stats</button><br>
		{/if}
		<!-- <button type="button" class="submitbtn" on:click={resetAnswers}>Reset</button> -->
	</div>
</div>

<style>
	#coupletcounters{
		text-align: center;
	}
	a.hint{
		font-weight:bold;
		font-family: "Georgia";
		color: var(--fg-color);
		display: block;
		width:100%;
		text-align: center;
	}
	.hintrowbtn {
		display: inline-block;
		width: 48%;
		text-transform: uppercase;
	}
</style>